import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const EurovisionIcon = observer('EurovisionIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            width='24'
            height='24'
            viewBox='0 0 50 50'
            fill='#061A32'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            onClick={onClick}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.1,36.11l7.68-6.6-6.28-6.28-6.6,7.68c-1.26,1.46-1.18,3.65.19,5.01h0c1.36,1.36,3.55,1.45,5.01.19ZM32.84,28.04c-.4.22-.82.41-1.25.55-1.09.37-2.24.5-3.37.4l-7.22-7.22c-.11-1.13.02-2.28.4-3.37.15-.43.33-.84.55-1.25l10.88,10.88ZM22.75,15.98c3-3.71,8.54-4,11.9-.63,3.36,3.36,3.08,8.9-.63,11.9l-11.27-11.27ZM22.18,28.8l-2.53,2.53-.98-.98,2.53-2.53.98.98Z'
                fill='fill'
            />
        </SvgIcon>
    );
});
